import AppLayout from '../layouts/AppLayout';
import UnauthorizedComponent from '../components/NoPermission/UnauthorizedComponent';

const UnauthorizedContainer: React.FC = () => {
  return (
    <AppLayout>
      <UnauthorizedComponent />
    </AppLayout>
  );
};

export default UnauthorizedContainer;
